/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import { Tooltip, Icon, Card } from "antd";
import GenericModal from "../../components/GenericModal";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class SelfServiceSpecialPagesView extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalView: false,
            pageNumber: null,
            pageName: null,
            columnCount: null,
            heightFlag: null,
        };

        this.id = "POS_BUTTON_LAYOUT_LIST";

        this.api = {
            get: "get_button_layout_button_list",
            get_meta: "get_layout_page_meta",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    loadData = () => {
        const { posId, pageId, user } = this.props
        const dataSend = { mPOSID: posId, mPageNumber: pageId }
        this.props.dataActions.genericDataSetFilter(this.id, user.companyCode, user.token, dataSend, this.api.get)
        this.sendAPI(this.api.get_meta, dataSend, ob => {
            const [pageNumber, pageName, heightFlag, columnCount] = ob.data ? ob.data.split("\f") : []
            this.setState({ pageNumber, pageName, heightFlag, columnCount })
        })
    }

    sendAPI = (script, data, sCallback) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCallback, e => { console.error(e) });
    }

    imgUrl = (x) => {
        let origin = window.location.origin;
        const isDev = origin == 'http://147.235.163.248' || origin == 'http://auto-club.co.il' || origin == 'http://localhost:3000'
        const baseUrl = isDev ? "http://147.235.163.248" : origin
        return baseUrl + "/uploads/" + this.props.user.companyCode + "/" + x;
    }

    render() {
        const gt = this.getText;

        return (<>
            <Tooltip title={gt(21993)}>
                <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"eye"} onClick={() => {
                    this.setState({ modalView: true }, this.loadData)
                }} />
            </Tooltip>
            <GenericModal
                visible={this.state.modalView}
                onCancel={() => { this.setState({ modalView: false }) }}
                title={`${gt(21991)} ${this.state.pageName} ${gt(21992)} ${this.props.posName}`}
                width={this.state.columnCount > 4 ? 50 + (this.state.columnCount * 100) : 450}>
                <div style={{ background: "#666666", width: this.state.columnCount * 100 }}>
                    {this.props.data[this.id].data.map(x => {
                        const [mNumber, mActionID, mImage, mColor, mValue1] = x.split("\f")
                        return (<Card
                            style={{
                                height: 90,
                                width: 90,
                                margin: 5,
                                display: "inline-block",
                                verticalAlign: "text-top",
                                background: mColor,
                                textAlign: "center",
                                lineHeight: 1
                            }}>
                            {mImage ? <img src={this.imgUrl(mImage)} width={50} height={50} /> : ""}
                            {mValue1}
                        </Card>)
                    })}
                </div>
            </GenericModal>
        </>)
    }

}

export default SelfServiceSpecialPagesView;